define( [
	"./arr"
], function( arr ) {
	return arr.indexOf;
} );



//////////////////
// WEBPACK FOOTER
// /~/jquery/src/var/indexOf.js
// module id = 618
// module chunks = 0